import type { RadioButtonState } from './cost-to-build-client-ui-radio-button.types';

export const RADIO_BUTTON_INITIAL_STATE: RadioButtonState = {
    ariaLabel: '',
    checked: false,
    disabled: false,
    id: '',
    label: '',
    name: '',
    value: '',
};

export const areRadioButtonStatesEqual = (left: RadioButtonState, right: RadioButtonState) =>
    left.ariaLabel === right.ariaLabel &&
    left.checked === right.checked &&
    left.disabled === right.disabled &&
    left.id === right.id &&
    left.label === right.label &&
    left.name === right.name &&
    left.value === right.value;
